import { render, staticRenderFns } from "./MenuModuleHeader.vue?vue&type=template&id=2cbe1f98&scoped=true"
import script from "./MenuModuleHeader.vue?vue&type=script&setup=true&lang=js"
export * from "./MenuModuleHeader.vue?vue&type=script&setup=true&lang=js"
import style0 from "./MenuModuleHeader.vue?vue&type=style&index=0&id=2cbe1f98&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cbe1f98",
  null
  
)

export default component.exports